import React from 'react';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

/**
 * PermissionsRevokedBanner - Shows when user permissions are revoked mid-session
 * Prompts user to refresh or re-login to get updated permissions
 */
const PermissionsRevokedBanner = () => {
  const { permissionsRevoked, dismissPermissionsRevoked, signOut } = useAuth();

  if (!permissionsRevoked) return null;

  return (
    <div className="fixed top-16 left-0 right-0 z-[999] bg-warning/10 border-b border-warning/30 px-4 py-2.5 flex items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        <Icon name="AlertTriangle" size={16} color="var(--color-warning)" />
        <span className="text-sm font-medium text-warning">
          Your permissions have been updated by an administrator. Some features may be restricted.
        </span>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          onClick={dismissPermissionsRevoked}
          className="text-xs text-muted-foreground hover:text-foreground transition-colors px-2 py-1 rounded hover:bg-muted"
        >
          Dismiss
        </button>
        <button
          onClick={signOut}
          className="text-xs font-medium text-warning hover:text-warning/80 transition-colors px-2 py-1 rounded hover:bg-warning/10 border border-warning/30"
        >
          Re-login to refresh
        </button>
      </div>
    </div>
  );
};

export default PermissionsRevokedBanner;
